module.exports = __webpack_public_path__ + "static/img/video-pass-off.3f138bf5.png";